import React, { useCallback, useMemo } from "react";

import ArrowRightIcon from "@mui/icons-material/ArrowRight";

import {
  EXPAND_COLLAPSE_CHILDREN,
  SET_ALL_LOCKED,
  SORT_ASSET_CLASS_WEIGHTS_DESC,
  SORT_ASSET_CLASSES_ASC,
} from "../../PortfolioBuilder/reducer/actions";
import { usePortfolioBuilderContext } from "../../PortfolioBuilder/reducer/Context";
import {
  areAllLocked,
  areAnyElementsExpanded,
} from "../../PortfolioBuilder/reducer/reducer";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Text from "@src/sharedComponents/Typography/Text";

import Lock from "./Lock/Lock";

import styles from "./TableRow.module.css";

const TopRow: React.FC = () => {
  const { state, dispatch } = usePortfolioBuilderContext();

  const areAllElementsLocked = useMemo(
    () => areAllLocked(state.modelTable),
    [state.modelTable]
  );

  const onClickLockAll = useCallback(() => {
    dispatch({
      type: SET_ALL_LOCKED,
      payload: {
        isLocked: !areAllElementsLocked,
      },
    });
  }, [dispatch, areAllElementsLocked]);

  const onSortAssetClassesAsc = () => {
    dispatch({
      type: SORT_ASSET_CLASSES_ASC,
      payload: undefined,
    });
  };

  const onSortAssetClassWeightsDesc = () => {
    dispatch({
      type: SORT_ASSET_CLASS_WEIGHTS_DESC,
      payload: undefined,
    });
  };

  const areAnyExpanded = useMemo(
    () =>
      state.modelTable.length === 0
        ? false
        : areAnyElementsExpanded(null, state.modelTable),
    [state.modelTable]
  );

  const onExpand = useCallback(() => {
    dispatch({
      type: EXPAND_COLLAPSE_CHILDREN,
      payload: {
        elementId: null,
        expand: !areAnyExpanded,
      },
    });
  }, [dispatch, areAnyExpanded]);

  return (
    <div className={styles.topRow}>
      <div className={styles.flexRow}>
        <ArrowRightIcon
          className={toClassName(styles.arrow, {
            [styles.arrowRotateDown]: areAnyExpanded,
            [styles.arrowRotateRight]: !areAnyExpanded,
          })}
          onClick={onExpand}
        />

        <Text
          className={styles.nameHeader}
          onClick={onSortAssetClassesAsc}
          variant="body"
          color={"textSubtle"}
        >
          Name
        </Text>
      </div>

      <div className={styles.flexRow}>
        <Text
          className={styles.weightHeader}
          onClick={onSortAssetClassWeightsDesc}
          variant="body"
          color={"textSubtle"}
        >
          Weight
        </Text>

        {false && (
          <Lock isLocked={areAllElementsLocked} onPress={onClickLockAll} />
        )}
      </div>
    </div>
  );
};

export default TopRow;
